<formio-loader></formio-loader>
<div class="indicators-wrapper">
    <h4>{{'forms.common.inicators' | translate}}</h4>
    <div class="row">
        <div class="col-sm-4" *ngFor="let indicator of indicators" (click)="openIndicator(indicator)">
            <div class="card">
                <div class="wave">
                    <svg viewBox="0 0 500 500" preserveAspectRatio="xMinYMin meet" style="z-index:-1;">

                        <path d="M0, 80 C300, 0 400,
            300 500, 50 L500, 00 L0, 0 Z" style="stroke: none;
            fill:rgb(52 53 126 / 93%);">
                        </path>
                    </svg>
                </div>
                <div class="wave">
                    <svg viewBox="0 0 500 500" preserveAspectRatio="xMinYMin meet" style="z-index:-3;">

                        <path d="M0, 100 C150, 300 350,
            0 500, 100 L500, 00 L0, 0 Z" style="stroke: none;
            fill:rgb(37 170 178 / 73%);">
                        </path>
                    </svg>
                </div>

                <span class="icon">
                    <i class="{{indicator.icon}}"></i>
                </span>

                <app-indicator-status class="status" [status]="indicator.status"></app-indicator-status>

                <span class="summary" *ngIf="!hideSummary"
                    (click)="$event.stopPropagation();openIndicator(indicator,true)">
                    {{'forms.common.indicatorShowSummary' | translate}}
                    <i class="fa fa-check-circle-o"></i>
                </span>

                <p class="content">
                    {{ 'forms.common.' + indicator.key | translate}}
                </p>
            </div>
        </div>
    </div>
</div>
